import * as d3 from 'd3';
import Highcharts from "highcharts";
import { StringHelpers } from "../../helpers/string-helpers";
import { IComponent } from "../component.interface";
import { IDrawingTool } from './drawing-tool.interface';
import { DrawingToolsManager } from "./drawing-tools.manager";

export class CurvedLineComponent implements IComponent, IDrawingTool {
    public id = '';

    public annotation: any = null;
    private drawingToolManager: DrawingToolsManager;

    constructor(drawingToolManager: DrawingToolsManager, id: string) {
        this.drawingToolManager = drawingToolManager;
        this.id = id;
    }

    public static syncCreate(drawingToolManager: DrawingToolsManager, annotationOptions: any): CurvedLineComponent {
        const chart: any = drawingToolManager.base.tiChartSeries.highStockChart;

        const addedNewAnnotation: any = chart.addAnnotation(annotationOptions);

        drawingToolManager.updateAnnotationStyles(addedNewAnnotation, annotationOptions, false);
        const component = new CurvedLineComponent(drawingToolManager, annotationOptions.id);
        component.annotation = addedNewAnnotation;
        return component;
    }

    public static create(drawingToolManager: DrawingToolsManager, cuvedPointsForNewAnnotation: any): CurvedLineComponent {
        const id = StringHelpers.newGuid();
        const series = drawingToolManager.base.tiChartSeries;
        const builder = drawingToolManager.base.tiChartSeries.highChartBuilder;
        const chart: any = drawingToolManager.base.tiChartSeries.highStockChart;

        if (chart && chart.navigationBindings) {
            chart.navigationBindings.selectedButton = null;
            chart.navigationBindings.selectedButtonElement = null;

            const element = document.querySelector('.highcharts-curved-line-custom-annotation');
            if (element) {
                element.classList.remove('highcharts-active');
            }

            builder.drawingToolStartInActive();
        }

        const newAnnotation = chart.addAnnotation(
            {
                langKey: 'curvedLine',
                class: 'crookedCurved',
                type: 'crookedLine',
                typeOptions: {
                    xAxis: 0,
                    yAxis: 0,
                    points: [


                        { x: chart.xAxis[0].toValue(cuvedPointsForNewAnnotation[0][0]), y: chart.yAxis[0].toValue(cuvedPointsForNewAnnotation[0][1]) },
                        { x: chart.xAxis[0].toValue(cuvedPointsForNewAnnotation[1][0]), y: chart.yAxis[0].toValue(cuvedPointsForNewAnnotation[1][1]) },
                        { x: chart.xAxis[0].toValue(cuvedPointsForNewAnnotation[2][0]), y: chart.yAxis[0].toValue(cuvedPointsForNewAnnotation[2][1]) },

                    ]
                },
                events: {
                    add: function (event) {
                        if (event.target?.options) {
                            event.target.options.id = StringHelpers.newGuid();
                        }
                        // me.saveAnnotations();
                        series.onAnnotationAdd(event, false);
                    },
                    afterUpdate: function (event) {
                        console.log('curved line afterUpdate ')

                        if (event.target.options.langKey == "curvedLine") {
                            event.target['dtcl_prop'] = 'thisCurved';
                            event.target.shapes.forEach(function (shape) {
                                shape.toD = function () {
                                    var dOption = this.options.d;
                                    if (dOption) {
                                        return typeof dOption === 'function' ?
                                            dOption.call(this) :
                                            dOption;
                                    }
                                    var points = this.points,
                                        len = points.length,
                                        d = [];
                                    var showPath = len,
                                        point = points[0],
                                        position = showPath && this.anchor(point).absolutePosition,
                                        pointIndex = 0,
                                        command;
                                    if (position) {
                                        d.push(['M', position.x, position.y]);
                                        while (++pointIndex < len && showPath) {
                                            point = points[pointIndex];
                                            command = point.command || 'L';
                                            position = this.anchor(point).absolutePosition;
                                            if (command === 'M') {
                                                d.push([command, position.x, position.y]);
                                            }
                                            else if (command === 'L') {
                                                d.push([command, position.x, position.y]);
                                            }
                                            else if (command === 'Z') {
                                                d.push([command]);
                                            }
                                            showPath = point.series.visible;
                                        }
                                    }

                                    var cline = builder.lineBetweenPoints([
                                        [d[0][1], d[0][2]],
                                        [d[1][1], d[1][2]],
                                        [d[2][1], d[2][2]],
                                    ]);
                                    var cd = ("M," + cline.substring(1)).split(",");
                                    d[0] = cd;
                                    d[1] = ['M', d[2][2], d[2][2]];
                                    d[2] = ['M', d[2][2], d[2][2]];

                                    return (showPath && this.graphic ?
                                        this.chart.renderer.crispLine(d, this.graphic.strokeWidth()) :
                                        null);
                                };
                            });
                            event.target.redraw();
                        }

                        if (event.target?.options && !event.target.options.id) {
                            event.target.options.id = StringHelpers.newGuid();
                        }
                        const afterDrawingToolCompleted = event && event.target && !event.target.isUpdating;
                        if (afterDrawingToolCompleted) {
                            drawingToolManager.saveAnnotations();
                        }
                        builder.drawingToolRibbonUpdate(() => {
                            series.onAnnotationAfterUpdate(event);
                        });
                    },
                    remove: function () {
                        drawingToolManager.delete();
                    }
                }
            }
        );

        // console.log(' newAnnotation' , newAnnotation)
        // newAnnotationXPosition = newAnnotationXPosition + 1000000000;
        newAnnotation['dtcl_prop'] = 'thisCurved';

        // newAnnotation.controlPoints.forEach(function (cp) {
        newAnnotation.shapes.forEach(function (shape) {
            shape.toD = function () {
                var dOption = this.options.d;
                if (dOption) {
                    return typeof dOption === 'function' ?
                        dOption.call(this) :
                        dOption;
                }
                var points = this.points,
                    len = points.length,
                    d = [];
                var showPath = len,
                    point = points[0],
                    position = showPath && this.anchor(point).absolutePosition,
                    pointIndex = 0,
                    command;
                if (position) {
                    d.push(['M', position.x, position.y]);
                    while (++pointIndex < len && showPath) {
                        point = points[pointIndex];
                        command = point.command || 'L';
                        position = this.anchor(point).absolutePosition;
                        if (command === 'M') {
                            d.push([command, position.x, position.y]);
                        }
                        else if (command === 'L') {
                            d.push([command, position.x, position.y]);
                        }
                        else if (command === 'Z') {
                            d.push([command]);
                        }
                        showPath = point.series.visible;
                    }
                }

                var cline = builder.lineBetweenPoints([
                    [d[0][1], d[0][2]],
                    [d[1][1], d[1][2]],
                    [d[2][1], d[2][2]],
                ]);
                var cd = ("M," + cline.substring(1)).split(",");
                d[0] = cd;
                d[1] = ['M', d[2][2], d[2][2]];
                d[2] = ['M', d[2][2], d[2][2]];

                return (showPath && this.graphic ?
                    this.chart.renderer.crispLine(d, this.graphic.strokeWidth()) :
                    null);
            };
        });
        
        newAnnotation.redraw();

        chart.navigationBindings.activeAnnotation = newAnnotation;
        newAnnotation.setControlPointsVisibility(true);
        d3.selectAll('.highcharts-control-points').raise();
        var annotation = newAnnotation;
        var navigation = newAnnotation.chart.navigationBindings;
        Highcharts.fireEvent(navigation, 'showPopup', {
            annotation: annotation,
            formType: 'annotation-toolbar',

            options: navigation.annotationToFields(annotation),
            onSubmit: function (data) {
                if (data.actionType === 'remove') {
                    navigation.activeAnnotation = false;
                    navigation.chart.removeAnnotation(annotation);
                }
                else {
                    var config: any = {};
                    navigation.fieldsToOptions(data.fields, config);
                    navigation.deselectAnnotation();
                    var typeOptions = config.typeOptions;
                    if (annotation.options.type === 'measure') {
                        // Manually disable crooshars according to
                        // stroke width of the shape:
                        typeOptions.crosshairY.enabled = (typeOptions.crosshairY
                            .strokeWidth !== 0);
                        typeOptions.crosshairX.enabled = (typeOptions.crosshairX
                            .strokeWidth !== 0);
                    }
                    annotation.update(config);
                }
            }
        });

        drawingToolManager.saveAnnotations();

        const component = new CurvedLineComponent(drawingToolManager, id);
        component.annotation = newAnnotation;
        return component;
    }

    public getMetaData(): any {
        return {
            id: this.id,
            langKey: 'curvedLine',
            type: 'crookedLine',
            typeOptions: {
                xAxis: 0,
                yAxis: 0,
                line: {
                    stroke: this.annotation.options.typeOptions.line.stroke,
                    fill: this.annotation.options.typeOptions.line.fill,
                    strokeWidth: this.annotation.options.typeOptions.line.strokeWidth
                },
                points: [{
                    x: this.annotation.options.typeOptions.points[0].x,
                    y: this.annotation.options.typeOptions.points[0].y,
                }, {
                    x: this.annotation.options.typeOptions.points[1].x,
                    y: this.annotation.options.typeOptions.points[1].y,
                }, {
                    x: this.annotation.options.typeOptions.points[2].x,
                    y: this.annotation.options.typeOptions.points[2].y,
                }]
            }
        };
    }
}